import { FC, useEffect, useState } from "react";
import styles from './index.module.less';
import right from '../../assets/right.svg';
import AnnoItem from './AnnoItem';
import Title from '../../common/title';
import { baseUrl } from "../../config";
import { getNotificationList, getNotificationDetail } from "../../api";


const Index: FC = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const getList = async () => {
        const res = await getNotificationList(1, 5);
        if (res.list) {
            const promises = res.list.map((item) => {
                return getNotificationDetail(item.id);
            })
            const all = await Promise.all(promises);
            setData(all);
            setLoading(false);
        }
    }

    useEffect(() => {
        getList();
    }, []);
    return (
        <div style={{height: props.height, width: props.width}} className={styles.body}>
            {/* <div className={styles['header-row']}>
                <div className={styles.header}>通知公告</div>
                <div className={styles.more}>
                    更多
                    <img className={styles.arrow} src={right} alt="" />
                </div>
            </div> */}
            <Title hasMore={true} path='/notification' title='通知公告'></Title>
            <div className={styles.content}>
                {
                    loading ?
                    <div className={styles.loading}>加载中...</div>
                    :
                    data.map((item) => {
                        return <AnnoItem {...item}></AnnoItem>
                    })
                }
            </div>
        </div>
    );
}

export default Index;